// extracted by mini-css-extract-plugin
export var footerContainer = "Footer-module--footerContainer--aqR0t";